import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  canvasAddPoints: ['points'],
  canvasClearPoints: [],
  canvasSetActive: ['isDrawing'],
  canvasSetStrokeColor: ['strokeColor']
})

export const CanvasTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  isDrawing: false,
  points: [],
  strokeColor: '#fbbd08'
})

/* ------------- Reducers ------------- */

export const canvasAddPoints = (state, { points }) => {
  return state.merge({ points: state.points.concat(points) })
}

export const canvasClearPoints = (state) => {
  return state.merge({ points: [] })
}

export const canvasSetActive = (state, { isDrawing }) => {
  return state.merge({ isDrawing })
}

export const canvasSetStrokeColor = (state, { strokeColor }) => {
  return state.merge({ strokeColor })
}

/* ------------- Selectors ------------- */

export const CanvasSelectors = {
  points: state => state.canvas.points
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.CANVAS_ADD_POINTS]: canvasAddPoints,
  [Types.CANVAS_CLEAR_POINTS]: canvasClearPoints,
  [Types.CANVAS_SET_ACTIVE]: canvasSetActive,
  [Types.CANVAS_SET_STROKE_COLOR]: canvasSetStrokeColor
})



// WEBPACK FOOTER //
// ./src/Redux/CanvasRedux.js